<template>
  <div class="music-card" @click="$emit('card-click')">
    <div class="image-container">
      <img :src="image" :alt="title" class="card-image">
      <div class="overlay">
        <div class="play-icon">
          <i class="play-button"></i>
        </div>
      </div>
    </div>
    <div class="card-title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'MusicCard',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: '歌名'
    },
    id: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>

<style scoped>
.music-card {
  width: 100%;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 15px;
}

.music-card:hover {
  transform: translateY(-5px);
}

.image-container {
  position: relative;
  width: 100%;
  padding-top: 135%; /* 1:1.3 比例，正方形 */
  overflow: hidden;
  border-radius: 4px;
  background-color: #f0f0f0;
}

.card-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s;
}

.music-card:hover .card-image {
  transform: scale(1.05);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.music-card:hover .overlay {
  opacity: 1;
}

.play-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.play-button {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 10px 20px;
  border-color: transparent transparent transparent #4169e1;
  margin-left: 5px;
}

.card-title {
  margin-top: 10px;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
</style> 